import { enqueueSnackbar } from "notistack";

export const snackbar = (message = "", type = "success", time = 3000) => {
  enqueueSnackbar(message, {
    variant: type,
    autoHideDuration: time,
    anchorOrigin: { vertical: "bottom", horizontal: "right" },
  });
};
